import type { OutputOperationResult } from './types';

export type FetchFunction<T, Args = never> = (...args: Args[]) => Promise<OutputOperationResult<T>>;

/**
 * A helper function that unwraps the result of OutputOperationResult.
 * It is useful when plugging the fetcher function into react-query.
 * So that you can get error out of OutputOperationResult in the returned state.
 */
export const resolve = async <T>(promise: Promise<OutputOperationResult<T>>, customErrorMessage?: string) => {
  const response = await promise;

  if (response.success) {
    return response.result;
  } else {
    return Promise.reject(customErrorMessage || response.error || 'Unknown error');
  }
};

/** A helper function that wraps a Promise with try catch, and return OutputOperationResult. */
export const safeResolve = async <T>(promise: Promise<T>): Promise<OutputOperationResult<T>> => {
  try {
    const result = await promise;
    return { success: true, result };
  } catch (error) {
    return { success: false, error: String(error) };
  }
};
